import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ArticleCategory } from './types';

export async function getCategories() {
  const url = '/web/studio/articles-categories';
  const response = await api.executeGetRequest<ObjectResponse<ArticleCategory[]>>(url);

  return response.data;
}
